import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { t } from 'ttag';
import SiteRoutes from './SiteRoutes';
import GenericErrorPage from "./Error/GenericErrorPage";

const PageRoutes = () => {
    return (
        <Routes>
            <Route
                path={`/404`}
                element={
                    <GenericErrorPage
                        title={t`Page not found`}
                        message={t`Sorry, we couldn’t find the page you were looking for.`}
                        buttonText={t`Go back to restaurant`}
                    />
                }
            />
            <Route
                path={`/500`}
                element={
                    <GenericErrorPage
                        title={t`Something went wrong`}
                        message={t`We’re having trouble completing this request right now. Please try again in a moment.`}
                        buttonText={t`Try again`}
                        reload={true}
                    />
                }
            />
            <Route path={`/*`} element={<SiteRoutes />} />
        </Routes>
    );
};

export default PageRoutes;
